import { useState } from "react";
import styles from "./TabbedCarousel.module.css";
import OverlayedImage from "../../components/OverlayedImage/OverlayedImage";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";

function TabbedCarousel({ data, className }) {
    const [currentTab, setCurrentTab] = useState(0);
    const [ref, , fadedClassName] = useIntersectionObserver(0.2);

    function handleTabClick(index) {
        setCurrentTab(index);
    }

    return (
        <div
            className={[styles.tabbed_carousel, fadedClassName, className].join(
                " "
            )}
            ref={ref}
        >
            <div className={styles.tabs_container}>
                {Object.keys(data).map((key, index) => (
                    <button
                        key={key}
                        className={[
                            styles.tab,
                            index === currentTab ? styles.active : undefined,
                        ].join(" ")}
                        onClick={() => handleTabClick(index)}
                    >
                        <span className={styles.tab_index}>
                            {(index + 1).toString().padStart(2, "0")}
                        </span>
                        <div className={styles.tab_label}>{key}</div>
                    </button>
                ))}
            </div>
            {((content) => {
                return (
                    <div
                        className={[
                            styles.current_content,
                            fadedClassName,
                        ].join(" ")}
                        key={currentTab}
                    >
                        <OverlayedImage src={content.baseImg} alt={content.alt}>
                            {content.overlays()}
                        </OverlayedImage>
                        <div className={styles.description}>
                            {content.description}
                        </div>
                    </div>
                );
            })(Object.values(data)[currentTab])}
        </div>
    );
}

export default TabbedCarousel;
